import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import PrivateDepartureMessagingTile from './PrivateDepartureMessagingTile'
import TailorMadeTourMessagingTile from './TailorMadeTourMessagingTile'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getIsPrivateRequestEnabled } from 'selectors/TourV2/tourV2OfferPageSelectors'
import type { OfferPageRoom, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    gap: ${rem(24)};
    grid-template-columns: repeat(auto-fill, minmax(${rem(400)}, 1fr));
  }
`

interface MappedStateProps {
  offer: App.Tours.TourV2Offer
  selectedVariation: App.Tours.TourV2OfferVariation
  isPrivateRequestEnabled: boolean
  travellers: Array<OfferPageRoom>
}

function AdditionalWaysToExperienceSection({ offer, selectedVariation, isPrivateRequestEnabled, travellers }: MappedStateProps) {
  return <Container>
    <TailorMadeTourMessagingTile tourOffer={offer} tourOfferVariation={selectedVariation} />
    {false && isPrivateRequestEnabled && <PrivateDepartureMessagingTile offer={offer} defaultTravellers={travellers} />}
  </Container>
}

export default withOfferPageAndReduxState((offerPageState: OfferPageState, appState: App.State): MappedStateProps => {
  return {
    offer: offerPageState.tourV2Offer!,
    selectedVariation: offerPageState.tourV2Variation!,
    isPrivateRequestEnabled: getIsPrivateRequestEnabled(offerPageState, appState),
    travellers: offerPageState.rooms,
  }
}, AdditionalWaysToExperienceSection)
